import React, { useState } from "react"
import { Alert, Button, Dialog, DialogActions, DialogContent, Stack, Typography } from "@mui/material"
import AgeGateModal from "../modals/AgeGateModal"
import ClosedModal from "../modals/ClosedModal"
import CropperModal from "../modals/CropperModal"
import HeadshotTipsModal from "../modals/HeadshotTipsModal"
import PermissionModal from "../modals/PermissionModal"
import SizeRejectionModal from "../modals/SizeRejectionModal"
import SwitchDeviceModal from "../modals/SwitchDeviceModal"
import BlueButton from "../buttons/BlueButton"
import { Gallery, GalleryPrivacy } from "../../library/Gallery"

const mockGallery = new Gallery({
  title: "Test Gallery",
  privacyLevel: GalleryPrivacy.PUBLIC,
  hashtag: "#test",
  _links: { "web:self": { href: "https://example.com" } },
  socialSharing: null,
  moderated: false,
  finePrint: null,
  totalUploads: 5,
})

// 1x1 red pixel as a placeholder image
const placeholderImage =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg=="

export default function ModalTestPage() {
  const [showAgeGate, setShowAgeGate] = useState(false)
  const [showClosed, setShowClosed] = useState(false)
  const [showCropper, setShowCropper] = useState(false)
  const [showHeadshotTips, setShowHeadshotTips] = useState(false)
  const [showPermission, setShowPermission] = useState(false)
  const [showSizeRejection, setShowSizeRejection] = useState(false)
  const [showSwitchDevice, setShowSwitchDevice] = useState(false)
  const [showAlert, setShowAlert] = useState(true)
  const [showShareSheet, setShowShareSheet] = useState(false)

  return (
    <Stack spacing={2} sx={{ p: 4, maxWidth: 400 }}>
      <Typography variant="h4">Modal Test Page</Typography>

      {showAlert ? (
        <Alert
          severity="warning"
          onClose={() => setShowAlert(false)}
        >
          The AI effect could not be applied. You can regenerate or continue with the original photo.
        </Alert>
      ) : (
        <Button variant="outlined" onClick={() => setShowAlert(true)}>
          Show Alert again
        </Button>
      )}

      <Button variant="contained" onClick={() => setShowAgeGate(true)}>
        AgeGateModal
      </Button>

      <Button variant="contained" onClick={() => setShowClosed(!showClosed)}>
        ClosedModal (toggle)
      </Button>

      <Button variant="contained" onClick={() => setShowCropper(true)}>
        CropperModal
      </Button>

      <Button variant="contained" onClick={() => setShowHeadshotTips(true)}>
        HeadshotTipsModal
      </Button>

      <Button variant="contained" onClick={() => setShowPermission(!showPermission)}>
        PermissionModal (toggle)
      </Button>

      <Button variant="contained" onClick={() => setShowSizeRejection(true)}>
        SizeRejectionModal
      </Button>

      <Button variant="contained" onClick={() => setShowSwitchDevice(true)}>
        SwitchDeviceModal
      </Button>

      <Button variant="contained" onClick={() => setShowShareSheet(true)}>
        ShareSheet Modal (PicPage)
      </Button>

      <AgeGateModal
        show={showAgeGate}
        prompt="Are you old enough?"
        minimumAge={21}
        passAgeGate={(didPass) => {
          alert(`Age gate passed: ${didPass}`)
          setShowAgeGate(false)
        }}
      />

      <ClosedModal show={showClosed} gallery={mockGallery} />

      <CropperModal
        show={showCropper}
        showFaceGuide={false}
        image={placeholderImage}
        onClose={() => setShowCropper(false)}
        finishCrop={(cropRect, image) => {
          console.log("Crop:", cropRect)
          setShowCropper(false)
        }}
      />

      <HeadshotTipsModal show={showHeadshotTips} onHide={() => setShowHeadshotTips(false)} />

      <PermissionModal show={showPermission} />

      <SizeRejectionModal
        show={showSizeRejection}
        minWidth={800}
        minHeight={800}
        onHide={() => setShowSizeRejection(false)}
      />

      <SwitchDeviceModal
        show={showSwitchDevice}
        participant={null}
        onHide={() => setShowSwitchDevice(false)}
      />

      <Dialog
        open={showShareSheet}
        onClose={() => setShowShareSheet(false)}
        slotProps={{ paper: { sx: { borderRadius: "0.7rem", maxWidth: 480 } } }}
      >
        <DialogContent sx={{ p: 4, textAlign: "center" }}>
          <Typography fontSize={28} fontWeight={500}>Share Sheet</Typography>
          <Typography fontSize={18} fontWeight={400} sx={{ mt: 1 }}>
            This is a placeholder for the ShareSheet component from PicPage. The real one requires an Upload and Gallery object.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <BlueButton onClick={() => setShowShareSheet(false)}>Close</BlueButton>
        </DialogActions>
      </Dialog>
    </Stack>
  )
}
